export default {
  'transactionSearch.customerReference': 'Customer Reference',
  'transactionSearch.error': 'Something went wrong',
  'transactionSearch.header': 'Transaction Search Criteria',
  'transactionSearch.hideAdditionalFilters': 'Hide Additional Filters',
  'transactionSearch.invalidRange': 'Invalid Range',
  'transactionSearch.noDataMessage': 'No transactions matched your search criteria.',
  'transactionSearch.refineSearch': 'Refine Search',
  'transactionSearch.searchAccountTypeOnly': 'Search <%= accountType %> Accounts',
  'transactionSearch.showAdditionalFilters': 'Show Additional Filters',
  'transactionSearch.transactionDescription': 'Transaction Description',
  'transactionSearch.transactionSearchLoanOrDepositOnly': 'Transaction Search',
  'transactionSearch.baiCode': 'BAI Code'
};
